module.exports = __webpack_public_path__ + "img/logo.60fdd330.svg";